<template>
  <v-dialog width="1000px" :value="value" scrollable @input="toggleModal()">
    <v-card class="kbLight">
      <v-toolbar class="kbLightBlue" dark flat text>
        <v-toolbar-title>
          {{ $t('general.administratorCallsList') }}
        </v-toolbar-title>

        <v-spacer />

        <v-btn icon @click="toggleModal()">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text v-if="loadingCalls">
        <LoadingComponent :circleSize="80"
                          :message="$t('general.loadingCalls')"
                          height="350px" />
      </v-card-text>

      <v-card-text v-else-if="!loadingCalls
                              && (!administratorCalls ||
                              !Array.isArray(administratorCalls) ||
                              !administratorCalls.length)">
        <NotFound :message="$t('general.administratorCallsNotFound')"
                  height="350px" />
      </v-card-text>

      <v-card-text v-else>
        <CallsList :calls="administratorCalls"
                   typeOfUser="admin" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import CallsList from '@/pages/App/Calls/CallsList'
import LoadingComponent from '@/components/ui/LoadingComponent'
import NotFound from '@/components/ui/NotFound'

export default {
  components: {
    CallsList,
    NotFound,
    LoadingComponent
  },
  computed: {
    ...mapState({
      administratorCalls: state => state.calls.administratorCalls
    })
  },
  data () {
    return {
      loadingCalls: false
    }
  },
  methods: {
    async getAdministratorCalls () {
      try {
        const data = { userId: this.selectedAdministratorId }
        this.loadingCalls = true
        await this.$store.dispatch('getAdministratorCalls', {
          companyId: this.$store.getters.companyUuid,
          appId: this.$store.getters.appUuid,
          data
        })
        this.loadingCalls = false
      } catch (e) {
        this.loadingCalls = false
        notifications.error(e)
      }
    },
    toggleModal () {
      this.$emit('input', false)
    }
  },
  props: {
    selectedAdministratorId: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (value) {
      if (value && this.selectedAdministratorId) {
        this.getAdministratorCalls()
      }
    }
  }
}
</script>
